import { render, staticRenderFns } from "./WeeksGroup.vue?vue&type=template&id=0b43c1f2&"
import script from "./WeeksGroup.vue?vue&type=script&lang=js&"
export * from "./WeeksGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports